import { render, staticRenderFns } from "./BaseFormField.vue?vue&type=template&id=6f2b7f2c&"
import script from "./BaseFormField.vue?vue&type=script&lang=js&"
export * from "./BaseFormField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports